import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AccountMenu from "./AccountMenu";

const AuthActions = () => {
  const { user, isAuthenticated } = useAuth();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}>
      {/* Divider from main nav */}
      <Box
        sx={{
          width: "1px",
          height: 28,
          backgroundColor: "#C4C4C4",
        }}
      />

      {!user || !isAuthenticated ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          {/* Log In */}
          <Typography
            onClick={() => navigate("/login")}
            sx={{
              cursor: "pointer",
              color: "#1A1A1A",
              fontSize: "1.15rem",
              fontWeight: 500,
              fontFamily: "Poppins",
              "&:hover": { color: "#FD7762" },
              whiteSpace: "nowrap",
            }}>
            Log In
          </Typography>

          {/* Sign Up Button */}
          <Box
            onClick={() => navigate("/signup")}
            sx={{
              px: 2,
              py: 0.6,
              borderRadius: "8px",
              border: "1px solid #FD7762",
              color: "#FD7762",
              fontSize: "1.15rem",
              fontWeight: 500,
              fontFamily: "Satoshi",
              cursor: "pointer",
              lineHeight: 1.1,
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "#FFEEE9",
              },
            }}>
            Sign Up
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <AccountMenu />
        </Box>
      )}
    </Box>
  );
};

export default AuthActions;
